import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFolder = createIcon({
  displayName: 'IconFolder',
  path: [
    <path
      key="0"
      d="M22 21H2V3H10.41L12.41 5H22V7H11.59L9.59 5H4V19H20V9H22V21Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
